<template>
  <a-modal
    ref="importData"
    :width="900"
    title="导入模版"
    :visible="excelVisible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirmValidate"
    :confirmLoading="confirmLoading"
  >
    <a-form-model
      ref="ruleForm"
      :model="commitdata"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      :rules="rules"
      class="full-width"
    >
      <a-form-model-item label="分配集名称" prop="assignmentSetId">
        <global-select
          ref="assignmentSetNameGS"
          :value.sync="commitdata.assignmentSetId"
          selectType="selectSearch"
          searchParam="inputString"
          requestApi="/mdm/mdmOrgSrAssignmentSets/selectList"
          :selectItem="{ value: 'selectedValue', label: 'label' }"
        />
      </a-form-model-item>
      <a-form-model-item label="期间" prop="forecastMonthTem">
        <a-range-picker
          class="rp-width"
          :placeholder="['开始日期', '结束日期']"
          valueFormat="YYYY-MM"
          format="YYYY-MM"
          :value="commitdata.forecastMonthTem"
          :mode="mode"
          @panelChange="handlePanelChange"
        />
      </a-form-model-item>

    </a-form-model>
  </a-modal>
</template>

  <script>
import Cookies from 'js-cookie'
import moment from 'moment';

// 表单字段
export default {

  props: {
    url: {
      type: String,
      default: () => {
        return ''
      }
    },
    sopDfcBasicDataId: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  data () {
    const url = this.url
    const token =
      process.env.NODE_ENV === 'development' || localStorage.getItem('isFromSystemLogin') === 'true'
        ? localStorage.getItem('token')
        : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined
    return {
      confirmLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },

      rules: {
        // forecastMonthTem: [{ required: true, message: '预测期间不能为空', trigger: 'change' }],
        assignmentSetId: [{ required: true, message: '分配集不能为空', trigger: 'change' }],
        forecastMonthTem: [{ required: true, message: '期间不能为空', trigger: 'change' }],
        fileList: [{ required: true, message: '上传文件不能为空', trigger: 'change' }]
      },
      commitdata: {
        assignmentSetId: '',
        monthStart: '', // 预测起始月
        monthEnd: '', // 预测起始月
        forecastMonthTem: [], // 临时时间
        forecastName: '', // 预测名称
        versionCode: '', // 版本
        versionDescription: '', // 版本描述
        scpBusinessUnit: '', // 事业部
        file: '', // 文件流
        fileList: []
      },
      isLoading: false,
      // 表单校验
      inputType: 2,
      mode: ['month', 'month'],
      // 导入excel
      excelVisible: false,
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '导入Excel',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: Authorization },
        // 上传的地址
        url: process.env.VUE_APP_API_BASE_URL + url,
        sopDfcBasicDataId: ''
      }
    }
  },
  created () {},
  methods: {
    handlePanelChange (value, mode) {
      const yearMonth1 = value[0].format('YYYY-MM')
      let yearMonth2 = value[1].format('YYYY-MM')
      if (this.yearMonthTem !== yearMonth1) {
        const yearAfter5MonthMoment = moment(yearMonth1, 'YYYY-MM').add(4, 'months');

        const yearAfter5Month = yearAfter5MonthMoment.format('YYYY-MM');
        yearMonth2 = yearAfter5Month
        value[1] = yearAfter5MonthMoment
      }
      this.commitdata.monthStart = yearMonth1
      this.commitdata.monthEnd = yearMonth2
      this.commitdata.forecastMonthTem = value
      this.yearMonthTem = yearMonth1
    },
        /** 导入excel */
    importExcelHandleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
      }
      if (status === 'done') {
        if (info.file.response.code === 200) {
          this.$message.success(`${info.file.name}: ${info.file.response.msg}`)
        } else {
          this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
        }
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
      }
    },
    show () {
      // this.addLine()
      this.excelVisible = true
    },
    // 关闭模态框
    close () {
      // this.reset()
      this.excelVisible = false
    },
    confirmValidate () {
        this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirm()
        }
      })
    },
    confirm () {
      this.confirmLoading = false
              // 关闭本组件
      this.excelVisible = false
      // 调用外部刷新列表方法
      // 刷新表单
      this.$message.warning('下载中')
      this.download('mdm/mdmOrgSrAssignments/download', {
        assignmentSetId: this.commitdata.assignmentSetId,
        monthStart: this.commitdata.monthStart,
        monthEnd: this.commitdata.monthEnd
        }, `成品分配比例导入模板_${moment().format('X')}.xlsx`)
        this.reset()
    },
        // 表单重置
    reset () {
      this.commitdata = {
        assignmentSetId: '',
        monthStart: '', // 预测起始月
        monthEnd: '' // 预测起始月
      }
    }
  }
}
</script>
<style scoped lang="less">
/deep/.ant-select {
  width: 180px;
}
/deep/.ant-input {
  width: 180px;
}
/deep/.ant-modal-body {
  height: 400px;
  overflow-y: scroll;
}
.rp-width {
  width: 200px;
}
.ip-width {
  width: 150px;
}
.full-width {
  width: 100%;
}
.col-tips {
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.4470588235294118);
  line-height: 22px;
}
</style>
